<template>
    <b-modal v-model="modal.show"
             hide-footer
             centered
             size="lg"
             :title="(editing ? 'Editar' : 'Crear') + ' GES' "
    >
        <hygienic_measurement/>
    </b-modal>
</template>


<script>
import {mapState} from 'vuex';
import hygienic_measurement from './hygienic_measurement.vue';

export default {
    name: 'modal',
    components: {
        hygienic_measurement
    },
    computed: {
        ...mapState('hygienic_measurements', [
            'hygienic_measurement',
            'editing',
            'modal'
        ])
    }
};
</script>
